export default function MineSweepIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="10" fill="#2F58B8" />
      <rect x="4" y="34" width="26" height="26" rx="4" fill="#13285A" />
      <rect x="34" y="4" width="26" height="26" rx="4" fill="#13285A" />
      <text x="47" y="25" textAnchor="middle" fontSize="20" fontWeight="900" fontFamily="Arial, sans-serif" fill="#2FD3C8">
        1
      </text>
      <text x="17" y="55" textAnchor="middle" fontSize="20" fontWeight="900" fontFamily="Arial, sans-serif" fill="#FFD84D">
        2
      </text>
      <circle cx="18" cy="20" r="9" fill="#1B1B2F" />
      <g stroke="#1B1B2F" strokeWidth="3.5" strokeLinecap="round">
        <path d="M18 7v26M5 20h26M9 11l18 18M27 11L9 29" />
      </g>
      <circle cx="15" cy="17" r="2.6" fill="#fff" />
      <path d="M41 56V36" stroke="#F2F4F7" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M42 36l14 6-14 6z" fill="#FF4D4D" />
    </svg>
  );
}
